import React from "react";
import useStyles from "./FmAllModals.style";

import { FmClearStepModal, FmFertilizationModal, FmSaveItemModal, FmSaveProcessModal, FmSaveProcessPrompt, FmErrorModal } from "..";

interface FmAllModals {
  clearModalIsOpen?: boolean;
  clearModalOnClose?: any;
  clearModalAction?: any;
  // ------------------------ //
  saveItemModalIsOpen?: boolean;
  saveItemModalOnClose?: any;
  saveItemModalAction?: any;
  // ----------------------- //
  saveProcessModalIsOpen?: boolean;
  saveProcessModalOnClose?: any;
  saveProcessModalAction?: any;
  // ----------------------- //
  ErrorRecipeIsOpen?: boolean;
  ErrorRecipeOnClose?: any;
  ErrorRecipeData?: string;

  // ----------------------- //
  FertilizationModalIsOpen?: boolean;
  FertilizationModalOnClose?: any;
  //------------------------
  SaveProcessPromptWhen?: any;
  SaveProcessPromptMessage?: string;
}

const FmAllModals = ({
  clearModalIsOpen,
  clearModalOnClose,
  clearModalAction,
  saveItemModalIsOpen,
  saveItemModalOnClose,
  saveItemModalAction,
  saveProcessModalIsOpen,
  saveProcessModalOnClose,
  saveProcessModalAction,
  SaveProcessPromptWhen,
  SaveProcessPromptMessage,
  FertilizationModalIsOpen,
  FertilizationModalOnClose,
  ErrorRecipeOnClose,
  ErrorRecipeIsOpen = false,
  ErrorRecipeData,
}: FmAllModals) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <FmClearStepModal img="assets/clear_image.png" isOpen={clearModalIsOpen} onClose={clearModalOnClose} clearModalAction={clearModalAction} />

      {/* ------------------------------- */}
      <FmSaveProcessModal
        img="assets/clear_image.png"
        isOpen={saveProcessModalIsOpen}
        onClose={saveProcessModalOnClose}
        saveProcessAction={saveProcessModalAction}
        when={true}
      />
      {/* ------------------------------- */}

      <FmSaveItemModal
        img="assets/save_item.png"
        onClose={saveItemModalOnClose}
        isOpen={saveItemModalIsOpen}
        saveItemModalAction={saveItemModalAction}
      />
      <FmFertilizationModal img="assets/Fertilization.png" onClose={FertilizationModalOnClose} isOpen={FertilizationModalIsOpen} />
      <FmErrorModal data={ErrorRecipeData} onClose={ErrorRecipeOnClose} isOpen={ErrorRecipeIsOpen} />
      {false && <FmSaveProcessPrompt when={SaveProcessPromptWhen} message={SaveProcessPromptMessage as string} />}
    </div>
  );
};

export default FmAllModals;
